import * as React from 'react';
import {
  StyledMessageDefault,
  StyledMessageDestructive,
  StyledMessageAttention,
  StyledMessageConfirmation,
} from './message-styled';
import { BaSeI18nContext } from '../../contexts/i18n';
import { BaSeHeading6 } from '../typography/heading/heading6';
import { BaSeParagraph } from '../typography/paragraph/paragraph';
import { ThemeNamedColor } from '../../theme/theme-interface';

const MessageTypes = {
  default: StyledMessageDefault,
  destructive: StyledMessageDestructive,
  confirmation: StyledMessageConfirmation,
  attention: StyledMessageAttention,
};

export interface MessageProps {
  color?: ThemeNamedColor;
  title?: string;
  message: string | string[];
}

const getStyledMessageFromType = (type: ThemeNamedColor) => {
  return MessageTypes[type] ?? StyledMessageDefault;
};

export const BaSeMessage: React.FC<MessageProps> = ({
  color = 'default',
  title,
  message,
}) => {
  const messages = React.useMemo(
    () => (Array.isArray(message) ? message : [message]),
    [message],
  );
  const { getMessage } = React.useContext(BaSeI18nContext);
  const StyledMessage = getStyledMessageFromType(color);
  const titleEl = title ?? getMessage(`message.${color}`);
  return (
    <StyledMessage>
      <BaSeHeading6 isBold={true}>{titleEl}</BaSeHeading6>
      {messages.map((msg, index) => (
        <BaSeParagraph key={index}>{msg}</BaSeParagraph>
      ))}
    </StyledMessage>
  );
};

BaSeMessage.displayName = 'BaSeMessage';
